<template>
    <!-- eslint-disable max-len -->
    <div :class="sidebarbg" class="app-sidebar sidebar-shadow" @mouseover="toggleSidebarHover('add','closed-sidebar-open')" @mouseleave="toggleSidebarHover('remove','closed-sidebar-open')">
        <div class="app-header__logo">
            <div class="logo-src"/>
            <div class="header__pane ml-auto">
                <button type="button" class="hamburger close-sidebar-btn hamburger--elastic" v-bind:class="{ 'is-active' : isOpen }" @click="toggleBodyClass('closed-sidebar')">
                    <span class="hamburger-box">
                        <span class="hamburger-inner"></span>
                    </span>
                </button>
            </div>
        </div>
        <div class="app-sidebar-content">
            <VuePerfectScrollbar class="app-sidebar-scroll" v-once>
                <sidebar-menu showOneChild :menu="menu"/>
            </VuePerfectScrollbar>
        </div>

    </div>
</template>

<script>
import { SidebarMenu } from 'vue-sidebar-menu';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';

export default {
  components: {
    SidebarMenu,
    VuePerfectScrollbar,
  },
  data() {
    return {
      isOpen: false,
      sidebarActive: false,
      menu: [
        {
          header: true,
          title: 'Dashboard',
        },
        {
          href: '/mockups/admin/',
          icon: 'pe-7s-home',
          title: 'Dashboard',
        },
        {
          header: true,
          title: 'Contacts',
        },
        {
          href: '/mockups/admin/contacts',
          title: 'All contacts',
          icon: 'pe-7s-users',
          // child: [
          //   {
          //     title: 'Contacts',
          //     href: '/mockups/admin/contacts',
          //   },
          //   {
          //     title: 'Clubs',
          //     href: '/mockups/admin/clients/clubs',
          //   },
          //   {
          //     title: 'Schools',
          //     href: '/mockups/admin/clients/schools',
          //   },
          //   {
          //     title: 'Companies',
          //     href: '/mockups/admin/clients/companies',
          //   },
          // ],
        },
        {
          href: '/mockups/admin/subscriptions',
          title: 'All subscriptions',
          icon: 'pe-7s-id',
        },
        {
          href: '/mockups/admin/documents',
          title: 'All documents',
          icon: 'pe-7s-albums',
        },
        {
          header: true,
          title: 'Occupation',
        },
        {
          href: '/mockups/admin/calendars',
          title: 'Calendars',
          icon: 'pe-7s-date',
        },
        {
          href: '/mockups/admin/bookings',
          title: 'Bookings',
          icon: 'pe-7s-bookmarks',
        },
        {
          href: '/mockups/admin/resources',
          title: 'Resources',
          icon: 'pe-7s-culture',
        },
        {
          header: true,
          title: 'Activities',
        },
        {
          href: '/mockups/admin/activities',
          title: 'Activities',
          icon: 'pe-7s-joy',
        },
        {
          href: '/mockups/admin/registrations',
          title: 'Registrations',
          icon: 'pe-7s-ticket',
        },
        {
          header: true,
          title: 'Accounting',
        },
        {
          href: '/mockups/admin/products',
          title: 'Products',
          icon: 'pe-7s-box2',
        },
        {
          href: '/mockups/admin/orders',
          title: 'Orders',
          icon: 'pe-7s-cart',
        },
        {
          href: '/mockups/admin/invoices',
          title: 'Invoices',
          icon: 'pe-7s-news-paper',
        },
        {
          href: '/mockups/admin/accounts',
          title: 'Accounts',
          icon: 'pe-7s-notebook', // 'pe-7s-calculator'
        },
        {
          header: true,
          title: 'Monitoring',
        },
        {
          href: '/mockups/admin/statistics',
          title: 'Statistics',
          icon: 'pe-7s-graph2',
        },
        {
          href: '/mockups/admin/reporting',
          title: 'Reporting',
          icon: 'pe-7s-note2',
        },
        {
          href: '/mockups/admin/logs',
          title: 'Logs',
          icon: 'pe-7s-timer',
        },
        {
          header: true,
          title: 'Configuration',
        },
        {
          href: '/mockups/admin/configuration',
          title: 'Configuration',
          icon: 'pe-7s-config',
        },
        {
          href: '/mockups/admin/parameters',
          title: 'Parameters',
          icon: 'pe-7s-tools',
        },
      ],
      collapsed: true,

      windowWidth: 0,

    };
  },
  props: {
    sidebarbg: String,

  },
  methods: {

    toggleBodyClass(className) {
      const el = document.body;
      this.isOpen = !this.isOpen;

      if (this.isOpen) {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    toggleSidebarHover(add, className) {
      const el = document.body;
      this.sidebarActive = !this.sidebarActive;

      this.windowWidth = document.documentElement.clientWidth;

      if (this.windowWidth > '992') {
        if (add === 'add') {
          el.classList.add(className);
        } else {
          el.classList.remove(className);
        }
      }
    },
    getWindowWidth() {
      const el = document.body;

      this.windowWidth = document.documentElement.clientWidth;

      if (this.windowWidth < '1350') {
        el.classList.add('closed-sidebar', 'closed-sidebar-md');
      } else {
        el.classList.remove('closed-sidebar', 'closed-sidebar-md');
      }
    },
  },
  mounted() {
    this.$nextTick(function () {
      window.addEventListener('resize', this.getWindowWidth);

      // Init
      this.getWindowWidth();
    });
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.getWindowWidth);
  },
};
</script>

<style>
    .logo-src, .closed-sidebar.closed-sidebar-open .app-sidebar .logo-src {
        background: url('../../assets/favicon-bigcaptain.svg');
        background-size: contain;
        background-repeat: no-repeat;
        /* background-position-x: -7px; */
        height: 40px;
        width: 40px;
    }
    .closed-sidebar:not(.closed-sidebar-open) .app-sidebar .logo-src {
        background: url('../../assets/bpc_logo_square.png');
        background-size: contain;
        background-repeat: no-repeat;
        background-position-x: 0px;
        height: 40px !important;
        width: 40px !important;
    }
</style>
